import {Divider, Grid, Typography} from '@material-ui/core';
import {Map as IMap, List} from 'immutable';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRow, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {GPLU_SPOUSE_WHOLE_LIFE_FIELD_ID, GPLUCoverageCode} from '../../../PlanTemplates/GWL/gpluConstants';
import {
  getAmountValuePath,
  getGPLUSpouseUnderWritingBlockPropertyPaths,
  getGPLUUnderWritingBlockPropertyPaths,
  getParentPath,
} from '../PropertyPaths';

export const GPLUSpouseUnderWritingBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue, updateQuoteFieldValues} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const underwritingAmounts: List<IMap<string, any>> = getQuoteFieldValue(
    `${getParentPath(selectedPlan?.planIndex, selectedCoverageIndex)}.underwriting.spouseUnderwritingAmounts`
  );
  const uwPropertyPaths = getGPLUUnderWritingBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const propertyPaths: any[] = (List.isList(underwritingAmounts)? underwritingAmounts.toArray() : underwritingAmounts?? [])
  .map((obj, index) =>
    getGPLUSpouseUnderWritingBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex, index, obj.get('_type'))
  );

  const irows: GridRowProps[] = [
    {
      rowProps: {key: 'row-56c06538-d797-4b59-a210-ad76f6c21ca3'},
      items: [
        {
          key: 'fd412f94-4337-4509-b969-65989a4df7d7',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Underwriting Type"
              id={uwPropertyPaths.underwritingTypeCd}
              value={getQuoteFieldValue(uwPropertyPaths.underwritingTypeCd)}
              onChange={e => updateQuoteFieldValue(uwPropertyPaths.underwritingTypeCd, e.target.value)}
              dropdownVariant="AttributeValue"
              searchKey="GPLUUnderwriting.underwritingTypeCd"
              coverageCode={GPLUCoverageCode.SPOUSE_WHOLE_LIFE}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: '0b331e0b-bae1-4d5d-9482-afa3182ace33',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="GI Time Period"
              id={uwPropertyPaths.giTimePeriod}
              value={getQuoteFieldValue(uwPropertyPaths.giTimePeriod)}
              onChange={e => updateQuoteFieldValue(uwPropertyPaths.giTimePeriod, e.target.value)}
              dropdownVariant="AttributeValue"
              coverageCode={GPLUCoverageCode.SPOUSE_WHOLE_LIFE}
              searchKey="GPLUUnderwriting.giTimePeriod"
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  const rows: GridRowProps[] = Array.from(propertyPaths).map(obj => {
    return {
      rowProps: {key: 'row-56c06538-d797-4b59-a210-ad76f6c21ca3'},
      title: obj.title,
      items: [
        {
          key: `${obj.spouseType}-5b815fc9-fc49-49ef-98c5-6e10ec9f56f7`,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="GI Amount"
              id={obj.guaranteedIssueAmount}
              value={getQuoteFieldValue(getAmountValuePath(obj.guaranteedIssueAmount))}
              onChange={e => {
                const benefitType = getQuoteFieldValue(obj.benefitTypeCd);
                updateQuoteFieldValues([
                  {path: getAmountValuePath(obj.guaranteedIssueAmount), newValue: e.target.value},
                  {path: getAmountValuePath(obj.maxUnderWritingLimitAllowance), newValue: e.target.value},
                  benefitType === 'RangeValues' && {
                    path: getAmountValuePath(obj.benefitMaxAmount),
                    newValue: e.target.value,
                  },
                  benefitType === 'SingleValue' && {
                    path: getAmountValuePath(obj.flatBenefitAmount),
                    newValue: e.target.value,
                  },
                ]);
              }}
              onKeyDown={e => {
                if (['.'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              formFieldId={GPLU_SPOUSE_WHOLE_LIFE_FIELD_ID[obj.spouseType].guaranteedIssueAmount}
              type="number"
              adornment="money"
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    };
  });

  return (
    <FormWrapper title="Underwriting" collapsible withSeparator expanded>
      <Grid container alignItems="center">
        <FormRowGrid rows={irows} />
        {rows?.map(
          ({items, rowProps, title, hidden}) =>
            !hidden && (
              <React.Fragment key={rowProps?.key}>
                {title && (
                  <>
                    <Typography variant="body1" style={{paddingLeft: '15px'}} className="lbl-main">
                      {title}
                    </Typography>
                    <Grid item xs={12}>
                      <Divider style={{width: '100%', margin: '10px 0', color: '#2F3847'}} />
                    </Grid>
                  </>
                )}
                <GridRow items={items} rowProps={rowProps} />
              </React.Fragment>
            )
        )}
      </Grid>
    </FormWrapper>
  );
};
